// extracted by mini-css-extract-plugin
export default {"container":"LaEG25_GZQZAihRSZgmf","closeButton":"O9qTqV_yUtmiprhpRbEA","title":"mER42Mq65laJNxEOUyeV","content":"euq7YVWuLpwjAZEpMHPy","flyingLaptops":"W3Dl1BQwnSGnFAfoj7qp"};